// English coverage for modules whose original catalogs were French-only or partial.
export const ENGLISH_SUPPLEMENT_TRANSLATIONS = {
  "immobilier.tabs.label": "Property & Stays journey",
  "immobilier.search.title": "Search for a property",
  "immobilier.search.zone": "Destination or area",
  "immobilier.search.zone_placeholder": "Cannes",
  "immobilier.search.type": "Property type",
  "immobilier.search.type.all": "All accommodation",
  "immobilier.search.type.apartment": "Apartment",
  "immobilier.search.type.villa": "Villa or house",
  "immobilier.search.type.room": "Room",
  "immobilier.search.arrival": "Arrival",
  "immobilier.search.departure": "Departure",
  "immobilier.search.dates": "Dates",
  "immobilier.search.travellers": "Travelers",
  "immobilier.search.entry_date": "Move-in date",
  "immobilier.search.furnished": "Furnished",
  "immobilier.search.room_type": "Room type",
  "immobilier.search.budget_min": "Minimum budget",
  "immobilier.search.budget_max": "Maximum budget",
  "immobilier.search.bedrooms": "Minimum bedrooms",
  "immobilier.search.loading": "Searching…",
  "immobilier.search.errors_title": "Some information needs to be corrected",
  "immobilier.error.zone_required": "Enter a destination or area.",
  "immobilier.error.date_invalid": "Choose a valid date.",
  "immobilier.error.departure_after": "Departure must be after arrival.",
  "immobilier.error.travellers": "Choose between 1 and 12 travelers.",
  "immobilier.error.budget": "Check the budget range.",
  "immobilier.entry.buy.title": "Buy or sell",
  "immobilier.entry.buy.text": "Explore a clear property journey, with transactions unavailable before launch.",
  "immobilier.entry.rent.title": "Long-term rentals",
  "immobilier.entry.rent.text": "Search for accommodation or prepare a future rental offer.",
  "immobilier.entry.stay.title": "Eternua Stays",
  "immobilier.entry.stay.text": "Discover stay previews linked to the same central property.",
  "immobilier.entry.roommate.title": "Shared housing",
  "immobilier.entry.roommate.text": "Search for a room or shared accommodation using neutral criteria.",
  "immobilier.results.count": "local previews",
  "immobilier.results.empty_title": "No previews match this search",
  "immobilier.results.empty_text": "Change the area, property type or number of travelers.",
  "immobilier.results.reset": "Reset search",
  "immobilier.card.capacity": "capacity",
  "immobilier.card.open": "Open listing",
  "immobilier.favorite.add": "Add to favorites",
  "immobilier.favorite.remove": "Remove from favorites",
  "immobilier.favorite.local_notice": "Favorites are stored only in this development browser.",
  "immobilier.summary.agenda_unavailable": "The Property Calendar source will be connected in a later phase.",
  "immobilier.summary.voyage_sync": "Synced with Travel",
  "immobilier.summary.search_only": "This search is neither a request nor a booking.",
  "immobilier.state.offline_title": "You are offline",
  "immobilier.state.offline_text": "Previously loaded previews remain available. No remote action is attempted.",
  "immobilier.state.error_title": "The preview could not be loaded",
  "immobilier.state.error_text": "Try again or return to the demo search.",
  "immobilier.state.unavailable_title": "Feature unavailable",
  "immobilier.state.unavailable_text": "This feature remains closed before launch.",
  "immobilier.state.session_title": "Your session is required",
  "immobilier.state.session_text": "Sign in to return to this journey without losing its context.",
  "immobilier.state.login": "Sign in",
  "immobilier.detail.back": "Back to results",
  "immobilier.detail.features": "Features",
  "immobilier.detail.amenities": "Demo amenities",
  "immobilier.detail.accessibility": "Accessibility",
  "immobilier.detail.contact": "Request information",
  "immobilier.detail.contact_unavailable": "Contact requests will be connected to the server in phase 2.",
  "immobilier.detail.no_payment": "No payment, deposit or confirmation is available.",
  "immobilier.publish.title": "Publish a stay",
  "immobilier.publish.subtitle": "Persistent listing saved on Eternua",
  "immobilier.publish.mode": "Journey",
  "immobilier.publish.property_title": "Listing title",
  "immobilier.publish.public_zone": "Approximate public area",
  "immobilier.publish.description": "Description",
  "immobilier.publish.save": "Publish stay",
  "immobilier.publish.saved": "Stay published on Eternua.",
  "immobilier.publish.moderation": "Submit for moderation",
  "immobilier.publish.moderation_unavailable": "Server submission is disabled in phase 1.",
  "immobilier.publish.private_warning": "Do not enter an exact address, identity document or financial information.",
  "immobilier.favorites.title": "My demo favorites",
  "immobilier.favorites.empty_title": "No local favorites",
  "immobilier.favorites.empty_text": "Add a preview from the Property & Stays page.",
  "immobilier.favorites.back": "Back to Property & Stays",
  "immobilier.demo.villa.title": "Pines Villa — local preview",
  "immobilier.demo.villa.description": "A contemporary villa overlooking the Mediterranean, shown only to test the local interface.",
  "immobilier.demo.villa.image_alt": "Demo Mediterranean villa with a pool and sea view",
  "immobilier.demo.apartment.title": "Horizon Apartment — local preview",
  "immobilier.demo.apartment.description": "A bright apartment with windows on both sides, used to test the Rent and Stay journeys.",
  "immobilier.demo.apartment.image_alt": "Bright demo living room with a balcony and sea view",
  "immobilier.demo.suite.title": "Suquet Suite — local preview",
  "immobilier.demo.suite.description": "A welcoming room used to test a stay offer and a shared housing search without a transaction.",
  "immobilier.demo.suite.image_alt": "Demo Mediterranean bedroom opening onto a terrace",

  "subscriptions.nav.public": "Premium",
  "subscriptions.nav.mine": "My subscription",
  "subscriptions.hero.eyebrow": "CLEAR PLANS THAT KEEP THE ESSENTIALS ACCESSIBLE",
  "subscriptions.hero.title": "Choose the tools that help your projects grow",
  "subscriptions.hero.subtitle": "Security, messaging and community features remain free. Paid plans add visibility, AI, analytics and professional tools.",
  "subscriptions.cycle.label": "Billing period",
  "subscriptions.cycle.monthly": "Monthly",
  "subscriptions.cycle.annual": "Annual",
  "subscriptions.cycle.month": "month",
  "subscriptions.cycle.year": "year",
  "subscriptions.cycle.annual_saving": "Two months free compared with monthly billing",
  "subscriptions.recommended": "Recommended",
  "subscriptions.price.free": "Free",
  "subscriptions.price.from": "From",
  "subscriptions.price.contact": "Custom quote",
  "subscriptions.plan.essential.name": "Eternua Essential",
  "subscriptions.plan.essential.tagline": "Everything you need to take part fully in Eternua.",
  "subscriptions.plan.premium.name": "Eternua Premium",
  "subscriptions.plan.premium.tagline": "More visibility and AI tools to go further.",
  "subscriptions.plan.pro.name": "Eternua Pro",
  "subscriptions.plan.pro.tagline": "A storefront and complete tools for your business.",
  "subscriptions.plan.enterprise.name": "Eternua Enterprise",
  "subscriptions.plan.enterprise.tagline": "Collaboration, governance and capacity tailored to your organization.",
  "subscriptions.cta.register": "Create a free account",
  "subscriptions.cta.login": "Sign in to choose",
  "subscriptions.cta.current": "View my subscription",
  "subscriptions.cta.choose": "Choose this plan",
  "subscriptions.cta.unavailable": "Subscription unavailable",
  "subscriptions.cta.contact": "Contact us",
  "subscriptions.cta.retry": "Try again",
  "subscriptions.cta.compare": "Compare all features",
  "subscriptions.loading.plans": "Loading Eternua plans…",
  "subscriptions.loading.mine": "Syncing your subscription…",
  "subscriptions.error.title": "Subscriptions are temporarily unavailable",
  "subscriptions.error.description": "No demo values are shown. Try again to load information from the server.",
  "subscriptions.offline.title": "You are offline",
  "subscriptions.offline.description": "Reconnect to view your actual subscription information.",
  "subscriptions.compare.title": "Full comparison",
  "subscriptions.compare.feature": "Feature",
  "subscriptions.compare.included": "Included",
  "subscriptions.compare.not_included": "Not included",
  "subscriptions.explain.title": "Three tools, three distinct uses",
  "subscriptions.explain.boost.title": "Boost credits",
  "subscriptions.explain.boost.text": "A Boost temporarily improves a listing’s visibility for 48 hours. It does not guarantee a sale, booking or result.",
  "subscriptions.explain.ai.title": "AI actions",
  "subscriptions.explain.ai.text": "An action is one request for improvement, correction, translation or a suggestion made through Eternua AI tools.",
  "subscriptions.explain.promo.title": "Promotional credits",
  "subscriptions.explain.promo.text": "These fund only internal Eternua services, such as boosts, storefronts and AI actions. They remain separate from real money and points.",
  "subscriptions.explain.sponsored": "A boost is labeled “Featured”. A separate advertising placement is labeled “Sponsored” or “Advertisement”.",
  "subscriptions.promo.welcome10": "10 free promotional credits – maximum usage value of €10",
  "subscriptions.promo.non_withdrawable": "Cannot be withdrawn",
  "subscriptions.promo.non_transferable": "Cannot be transferred",
  "subscriptions.promo.no_member_payment": "Cannot be used to pay another member",
  "subscriptions.promo.no_crowdfunding": "Cannot fund a fundraiser or donation",
  "subscriptions.promo.internal_only": "For internal Eternua services only",
  "subscriptions.faq.title": "Frequently asked questions",
  "subscriptions.faq.free.q": "Is the free plan really usable?",
  "subscriptions.faq.free.a": "Yes. Profiles, identity, standard listings, search, messaging, applications, groups, crowdfunding, the calendar, missions, the wallet and basic analytics remain available.",
  "subscriptions.faq.messaging.q": "Can messaging or security be blocked?",
  "subscriptions.faq.messaging.a": "No. Regular messaging, security and identity verification never depend on a paid subscription.",
  "subscriptions.faq.boost.q": "Does a Boost guarantee a sale?",
  "subscriptions.faq.boost.a": "No. It only increases visibility for a defined period. Sponsored content remains identified as such.",
  "subscriptions.faq.quotas.q": "Do unused allowances roll over?",
  "subscriptions.faq.quotas.a": "No. Boost credits and AI actions renew each month on the subscription’s billing date, without automatic rollover.",
  "subscriptions.faq.cancel.q": "What happens after cancellation?",
  "subscriptions.faq.cancel.a": "Paid benefits remain active until the end of the period already paid for. Your listings and data are not deleted.",
  "subscriptions.faq.enterprise.q": "How do I subscribe to Enterprise?",
  "subscriptions.faq.enterprise.a": "The plan is configured with a custom quote. Contact Eternua to define collaborators, capacity, locations and governance.",
  "subscriptions.mine.eyebrow": "PERSONAL SPACE",
  "subscriptions.mine.title": "Subscriptions and promotions",
  "subscriptions.mine.subtitle": "Status, due dates, boosts, payments and preferences confirmed by the server.",
  "subscriptions.mine.current_offer": "Current plan",
  "subscriptions.mine.status": "Status",
  "subscriptions.mine.price": "Price",
  "subscriptions.mine.billing_cycle": "Cycle",
  "subscriptions.mine.next_billing": "Next billing date",
  "subscriptions.mine.ends_at": "Paid benefits end",
  "subscriptions.mine.no_due_date": "No due date",
  "subscriptions.mine.no_end_date": "No scheduled end date",
  "subscriptions.mine.change": "Change plan",
  "subscriptions.mine.cancel": "Cancel online",
  "subscriptions.mine.reactivate": "Reactivate subscription",
  "subscriptions.mine.cancel_confirm_title": "Schedule cancellation?",
  "subscriptions.mine.cancel_confirm_text": "Your benefits remain active until the displayed end date. No listings or data will be deleted.",
  "subscriptions.mine.cancel_confirm": "Confirm cancellation",
  "subscriptions.mine.cancel_keep": "Keep my plan",
  "subscriptions.mine.action_pending": "Secure update in progress…",
  "subscriptions.mine.payment_disabled": "Payments are intentionally disabled. No real charge can be triggered from this version.",
  "subscriptions.mine.pending_payment": "Activation awaiting test payment confirmation.",
  "subscriptions.mine.past_due": "Payment overdue. Check your status before the due date.",
  "subscriptions.mine.cancel_scheduled": "Cancellation scheduled: your benefits remain active until the end date.",
  "subscriptions.mine.expired": "This subscription has expired. Only Essential benefits remain active.",
  "subscriptions.mine.usage_title": "Your monthly benefits",
  "subscriptions.mine.boosts": "Available boosts",
  "subscriptions.mine.ai_actions": "Remaining AI actions",
  "subscriptions.mine.renews": "Renewal",
  "subscriptions.mine.no_renewal": "No renewal for this plan",
  "subscriptions.mine.promo_title": "Promotional credits",
  "subscriptions.mine.promo_balance": "Promotional balance",
  "subscriptions.mine.separate_balances": "This balance is technically separate from your real money and reward points.",
  "subscriptions.mine.promo_history_link": "View the full history in your wallet",
  "subscriptions.mine.history_title": "Usage history",
  "subscriptions.mine.history_empty": "No usage recorded yet.",
  "subscriptions.mine.changes_title": "Change history",
  "subscriptions.mine.changes_empty": "No subscription changes recorded.",
  "subscriptions.mine.invoices_title": "Invoices",
  "subscriptions.mine.invoices_empty": "No actual invoices are available.",
  "subscriptions.mine.invoices_empty_detail": "An invoice will appear only after being issued by a configured payment provider.",
  "subscriptions.mine.module_title": "Main professional module",
  "subscriptions.mine.module_help": "Choose the module that structures your Pro storefront. Other modules can be added later.",
  "subscriptions.mine.module_save": "Save module",
  "subscriptions.status.incomplete": "Incomplete",
  "subscriptions.status.active": "Active",
  "subscriptions.status.past_due": "Past due",
  "subscriptions.status.cancel_scheduled": "Cancellation scheduled",
  "subscriptions.status.canceled": "Canceled",
  "subscriptions.status.expired": "Expired",
  "subscriptions.module.seller": "Seller",
  "subscriptions.module.services": "Services",
  "subscriptions.module.host": "Host",
  "subscriptions.module.real_estate": "Property",
  "subscriptions.module.recruiter": "Recruiter",
  "subscriptions.module.crowdfunding": "Crowdfunding",
  "subscriptions.event.boost": "Boost used",
  "subscriptions.event.ai_action": "AI action used",
  "subscriptions.event.created": "Subscription created",
  "subscriptions.event.plan_changed": "Plan changed",
  "subscriptions.event.cancel_scheduled": "Cancellation scheduled",
  "subscriptions.event.reactivated": "Subscription reactivated",
  "subscriptions.event.expired": "Subscription expired",
  "subscriptions.event.module_changed": "Professional module changed",
  "subscriptions.feature.profile_customization": "Profile creation and customization",
  "subscriptions.feature.identity_and_security": "Identity verification and security",
  "subscriptions.feature.standard_listings": "Standard listing publication",
  "subscriptions.feature.search_favorites_simple_alerts": "Search, favorites and basic alerts",
  "subscriptions.feature.member_messaging": "Member messaging",
  "subscriptions.feature.job_applications": "Job applications",
  "subscriptions.feature.community_travel_services_groups": "Outings, travel, services and groups",
  "subscriptions.feature.crowdfunding_participation": "Crowdfunding participation",
  "subscriptions.feature.agenda_missions_points_rewards": "Calendar, missions, points and rewards",
  "subscriptions.feature.guided_journey": "Journey guided by LIA",
  "subscriptions.feature.wallet_and_history": "Wallet and history",
  "subscriptions.feature.simple_statistics": "Basic analytics",
  "subscriptions.feature.standard_support": "Standard support",
  "subscriptions.feature.boost_allowance": "Boost credits renewed every month",
  "subscriptions.feature.boost_duration": "Featured listing",
  "subscriptions.feature.scheduled_boosts": "Scheduled boosts",
  "subscriptions.feature.ai_action_allowance": "Monthly AI actions",
  "subscriptions.feature.ai_assistance": "AI improvement, correction, translation and suggestions",
  "subscriptions.feature.listing_media": "Photos and videos per listing",
  "subscriptions.feature.listing_workflow": "Drafts, duplication and scheduling",
  "subscriptions.feature.advanced_alerts": "Advanced alerts and saved searches",
  "subscriptions.feature.statistics_range": "Detailed analytics",
  "subscriptions.feature.premium_profile": "Customizable Premium profile",
  "subscriptions.feature.premium_badge": "Premium badge separate from the “Declared identity” label",
  "subscriptions.feature.partner_ads": "Partner advertising",
  "subscriptions.feature.early_access": "Early access to new features",
  "subscriptions.feature.professional_storefront": "Professional storefront",
  "subscriptions.feature.catalogue_collections": "Catalog organized into collections",
  "subscriptions.feature.scheduled_promotions": "Scheduled promotions and publications",
  "subscriptions.feature.professional_statistics": "Professional analytics",
  "subscriptions.feature.bulk_listing_management": "Bulk listing management",
  "subscriptions.feature.csv_import_export": "CSV import and export",
  "subscriptions.feature.message_templates": "Message templates and quick replies",
  "subscriptions.feature.stock_and_availability": "Stock and availability",
  "subscriptions.feature.booking_calendar": "Booking calendar",
  "subscriptions.feature.agenda_sync": "Eternua calendar sync",
  "subscriptions.feature.accounting_exports": "Accounting exports",
  "subscriptions.feature.monthly_reports": "Monthly reports",
  "subscriptions.feature.multilingual_translation": "Multilingual translation",
  "subscriptions.feature.professional_modules": "Professional modules",
  "subscriptions.feature.multiple_collaborators": "Multiple collaborators",
  "subscriptions.feature.roles_and_approval": "Owner, administrator, editor, support and analyst roles, with approval before publication",
  "subscriptions.feature.multiple_locations": "Multiple stores, agencies or locations",
  "subscriptions.feature.global_team_dashboard": "Global dashboard and team analytics",
  "subscriptions.feature.action_audit_log": "Action history",
  "subscriptions.feature.centralized_billing": "Centralized billing",
  "subscriptions.feature.advanced_exports": "Advanced exports",
  "subscriptions.feature.enforced_collaborator_2fa": "Required 2FA for collaborators",
  "subscriptions.feature.future_api_webhooks": "API and webhooks prepared",
  "subscriptions.value.0": "0",
  "subscriptions.value.3_monthly": "3 / month",
  "subscriptions.value.20_monthly": "20 / month",
  "subscriptions.value.25_monthly": "25 / month",
  "subscriptions.value.150_monthly": "150 / month",
  "subscriptions.value.custom": "Custom capacity",
  "subscriptions.value.48_hours": "48 hours",
  "subscriptions.value.standard": "Standard",
  "subscriptions.value.extended": "Extended",
  "subscriptions.value.simple": "Basic",
  "subscriptions.value.7_30_90_days": "7, 30 and 90 days",
  "subscriptions.value.professional": "Professional",
  "subscriptions.value.team": "Team and global",
  "subscriptions.value.identified": "Present and labeled",
  "subscriptions.value.none": "None",
  "subscriptions.value.prepared": "Prepared, inactive",

  "trust.title": "My Trust Passport",
  "trust.eyebrow": "SEPARATE FACTS, NEVER AN OPAQUE SCORE",
  "trust.subtitle": "Assess what has actually been verified, interaction by interaction.",
  "trust.loading": "Securely loading your passport…",
  "trust.offline": "You are offline. Reconnect to load actual data.",
  "trust.error": "The Trust Passport is temporarily unavailable.",
  "trust.retry": "Try again",
  "trust.verifications": "My verifications",
  "trust.interactions": "Confirmed interactions",
  "trust.reviews": "Reviews linked to a confirmed interaction",
  "trust.request": "Request verification",
  "trust.email.action": "Send confirmation link",
  "trust.phone.unavailable": "Verification temporarily unavailable",
  "trust.data.insufficient": "Insufficient data",
  "trust.premium.label": "Premium",
  "trust.verified.label": "Verified by Eternua",
  "trust.public.title": "Eternua Trust Passport",
  "trust.public.understand": "Understand this information",
  "trust.public.member_since": "Member since",
  "trust.public.interactions": "confirmed interactions",
  "trust.public.reviews": "published reviews",
  "trust.empty": "No confirmed data to display yet.",

  "journey.eyebrow": "MY JOURNEY",
  "journey.empty.title": "What is your goal today?",
  "journey.empty.text": "Choose a journey and move forward step by step with LIA.",
  "journey.back.home": "Back to My Journey",
  "journey.error.title": "Your journey is temporarily unavailable",
  "journey.error.text": "Your data remains saved. Try again in a moment.",
  "journey.offline.title": "You are offline",
  "journey.offline.text": "Reconnect to return to your saved journey.",
  "journey.deadline": "Next due date",
  "journey.recent": "Recently completed steps",
  "journey.none.recent": "No steps completed yet.",
  "journey.deadlines.near": "Upcoming due dates",
  "journey.deadlines.none": "No upcoming due dates.",
  "journey.active.count": "active journeys",
  "journey.available.count": "7 available goals · No credits used",
  "journey.steps.done": "completed steps",
  "journey.wizard.title": "Create a journey",
  "journey.wizard.goal": "What is your main goal?",
  "journey.wizard.common": "A few details to organize your journey",
  "journey.wizard.specific": "One final question tailored to your goal",
  "journey.wizard.summary": "Summary of your answers",
  "journey.wizard.preview": "Step preview",
  "journey.wizard.help": "Your answers are used only to select and order predefined steps.",
  "journey.wizard.previous": "Previous",
  "journey.wizard.next": "Continue",
  "journey.wizard.preview.action": "Prepare preview",
  "journey.wizard.validate": "Confirm and create my journey",
  "journey.wizard.creating": "Saving your journey…",
  "journey.wizard.select": "Choose an answer",
  "journey.wizard.optional": "Optional",
  "journey.wizard.change": "Edit my answers",
  "journey.wizard.step.goal": "Goal",
  "journey.wizard.step.common": "Details",
  "journey.wizard.step.specific": "Tailored question",
  "journey.wizard.step.summary": "Summary",
  "journey.wizard.step.preview": "Preview",
  "journey.wizard.steps.label": "Creation steps",
  "journey.wizard.preparing": "Preparing…",
  "journey.wizard.preview.text": "These steps will be saved once. You can then follow, postpone or skip them.",
  "journey.wizard.due.proposed": "Proposed due date",
  "journey.wizard.verification": "VERIFICATION",
  "journey.wizard.validation": "CONFIRMATION",
  "journey.detail.timeline": "Journey steps",
  "journey.detail.history": "Recent activity",
  "journey.detail.checklist": "PRIVATE CHECKLIST",
  "journey.detail.due": "Due date",
  "journey.detail.version": "TEMPLATE",
  "journey.detail.privacy": "This journey never appears on your public profile.",
  "journey.step.start": "Start",
  "journey.step.complete": "Mark as complete",
  "journey.step.undo": "Undo confirmation",
  "journey.step.skip": "Skip this step",
  "journey.step.restore": "Restore step",
  "journey.step.postpone": "Postpone by 7 days",
  "journey.step.agenda": "Add to calendar",
  "journey.step.agenda.done": "Added to calendar",
  "journey.step.open": "Open Eternua section",
  "journey.status.todo": "To do",
  "journey.status.in_progress": "In progress",
  "journey.status.completed": "Complete",
  "journey.status.skipped": "Skipped",
  "journey.archive": "Archive journey",
  "journey.archive.confirm": "Archive this journey? Its steps and progress will be preserved.",
  "journey.complete": "Mark journey as complete",
  "journey.complete.help": "All steps must be completed or skipped.",
  "journey.history.title": "Journey history",
  "journey.history.eyebrow": "PRIVATE ARCHIVES",
  "journey.history.active": "Active",
  "journey.history.completed": "Completed",
  "journey.history.archived": "Archived",
  "journey.history.empty": "No journeys in this category.",
  "journey.restore": "Restore journey",
  "journey.open": "Open journey",
  "journey.activity.journey_created": "Journey created",
  "journey.activity.step_start": "Step started",
  "journey.activity.step_complete": "Step completed",
  "journey.activity.step_undo": "Confirmation undone",
  "journey.activity.step_skip": "Step skipped",
  "journey.activity.step_restore": "Step restored",
  "journey.activity.step_postpone": "Due date postponed",
  "journey.activity.agenda_added": "Due date added to calendar",
  "journey.activity.agenda_updated": "Calendar due date updated",
  "journey.activity.journey_archived": "Journey archived",
  "journey.activity.journey_restored": "Journey restored",
  "journey.activity.journey_completed": "Journey completed",

  "live_map.nav": "Live Map",
  "live_map.title": "Eternua Live Map",
  "live_map.hero": "Discover what is happening around you without revealing your address.",
  "live_map.approximate": "Approximate location and distance",
  "live_map.list": "List",
  "live_map.map": "Map",
  "live_map.use_position": "Use my location once",
  "live_map.position_help": "Your location is immediately rounded, used for this search and then forgotten.",
  "live_map.manual_label": "City or postal code",
  "live_map.manual_placeholder": "E.g. Lyon or 69001",
  "live_map.search": "Search",
  "live_map.search_area": "Search this area",
  "live_map.filters": "Filters",
  "live_map.clear_filters": "Clear filters",
  "live_map.categories": "Categories",
  "live_map.radius": "Radius",
  "live_map.free": "Free only",
  "live_map.results": "results",
  "live_map.no_results": "No results with the current filters.",
  "live_map.initial": "Choose a city or postal code, or use your location once.",
  "live_map.loading": "Searching around this area…",
  "live_map.error": "The search could not be completed. Try again.",
  "live_map.offline": "You are offline. The most recently displayed list remains available.",
  "live_map.provider_missing": "Live Map coming soon",
  "live_map.list_still_works": "City search and list view remain fully usable.",
  "live_map.privacy_title": "Your privacy stays at the center",
  "live_map.privacy_text": "No exact address, live location, directions to a home or presence times are displayed.",
  "live_map.detail": "Compact listing",
  "live_map.hide": "Hide this content",
  "live_map.block": "Block this member",
  "live_map.report": "Report a location issue",
  "live_map.close": "Close",
  "live_map.publish_title": "My Live Map publications",
  "live_map.publish_text": "Each item requires separate consent. Visibility is disabled by default.",
  "live_map.visible": "Visible on the Live Map",
  "live_map.hidden": "Not visible",
  "live_map.zone": "Displayed public area",
  "live_map.precision": "Approximation level",
  "live_map.standard": "Standard area",
  "live_map.wide": "Wider area",
  "live_map.consent": "I confirm that I want this content to be visible within this approximate area.",
  "live_map.activate": "Enable visibility",
  "live_map.deactivate": "Disable immediately",
  "live_map.photo_warning": "Check that your description and photos do not unintentionally reveal an address or private location.",
  "live_map.activity_title": "I am looking for an activity",
  "live_map.activity_text": "Voluntary, temporary publication for verified adult members only.",
  "live_map.activities": "Activities wanted",
  "live_map.availability": "General availability",
  "live_map.duration": "Duration",
  "live_map.publish_activity": "Publish my search",
  "live_map.revoke_activity": "Remove my search",
  "live_map.location_denied": "Location access denied. Search by city or postal code.",
  "live_map.location_unavailable": "Location unavailable. List view remains accessible.",

  // Newer callers also use keys absent from both original language catalogs.
  "nav.market.encheres": "Auctions",
  "nav.market.flash": "Flash sales",
  "nav.market.suggere": "Suggested",
  "nav.market.babysitting": "Babysitting",
  "acheter.tab.affaires": "Current deals",
  "vendre.tab.publier_flash": "Publish a flash sale",
  "vendre.tab.publier_enchere": "Publish an auction",
  "vendre.tab.affaires": "Current deals",
  "vendre.tab.paiement": "Payments",
  "vendre.tab.paiement_finalise": "Completed payments",
  "vendre.tab.affaires_terminees": "Completed deals",
  "header.convergence_collective": "Collective convergence",
  "acheter.navigation.close": "Close Buy navigation",
  "acheter.navigation.intro": "Your discoveries and purchases, all in one place.",
  "acheter.navigation.title": "Buy navigation",
  "acheter.navigation.explore": "Explore",
  "acheter.navigation.space": "Your space",
  "acheter.navigation.shortcuts": "In this section",
  "acheter.navigation.cart": "View my cart",
  "immobilier.error.people": "Choose between 1 and 12 people.",
  "journey.step.reschedule": "Change date",
  "immobilier.detail.unavailable": "Property listing unavailable",
  "animaux.adoption.metrics.concluded_site": "completed on the site",
  "animaux.adoption.publish.photos.limit": "Maximum 5 photos.",
  "animaux.adoption.browse.address.ok": "Search area updated.",
  "animaux.adoption.post.delete_error": "Unable to delete.",
  "animaux.adoption.post.deleted": "Listing deleted.",
  "animaux.adoption.favori.contact.no_user": "Username not found for this profile.",
  "animaux.adoption.favori.contact.already_friend": "This person is already your friend.",
  "animaux.adoption.favori.contact.pending": "Friend request already pending.",
  "animaux.adoption.favori.contact.error": "Unable to send the friend request.",
  "animaux.adoption.favori.contact.sent": "Friend request sent.",
  "animaux.adoption.rencontre.removed": "Exchange removed from Meet.",
  "animaux.adoption.rencontre.finalize_error": "Unable to confirm.",
  "animaux.adoption.rencontre.finalized": "Transaction completed.",
  "animaux.adoption.rencontre.finalize_wait": "Confirmation saved. Waiting for the other person.",
  "animaux.adoption.rencontre.review.rating_required": "Add a rating between 1 and 5.",
  "animaux.adoption.rencontre.review.error": "Unable to save the review.",
  "animaux.adoption.rencontre.review.saved": "Review saved.",
  "animaux.adoption.rencontre.accept.error": "Unable to accept the friend request.",
  "animaux.adoption.rencontre.accept.ok": "Friend request accepted.",
  "animaux.adoption.favori.msg.need_friend": "A friend request is required before sending a message.",
  "animaux.adoption.friend.msg_sent": "Message already sent",
  "animaux.adoption.friend.msg": "Send a message",
  "animaux.adoption.contact.friend_only": "This listing has no phone number or email address. Contact the person through a friend request.",
  "common.copied": "Copied",
  "animaux.adoption.publish.error.required": "Complete the required fields: city, area, details and confirmation.",
  "animaux.adoption.publish.error.address_profile": "No address is saved in your public profile for this choice.",
  "animaux.adoption.publish.error.contact_modes": "Choose between 1 and 3 contact methods.",
  "animaux.adoption.publish.error.phone": "Add a phone number.",
  "animaux.adoption.publish.error.email": "Add a valid email address.",
  "animaux.adoption.publish.error.address_not_found": "Address not found. Add a more precise address (number, street, city and postal code).",
  "animaux.adoption.publish.need_login": "Sign in to publish online.",
  "animaux.adoption.publish.error.generic": "Publication rejected.",
  "animaux.adoption.publish.ok": "Listing published and synced with the Animals service.",
  "animaux.adoption.publish.no_name": "Unnamed",
  "animaux.adoption.post.not_found": "Listing not found or deleted.",
  "animaux.adoption.rencontre.status.accepted": "Friend request accepted",
  "animaux.adoption.rencontre.status.incoming": "Received request pending",
  "animaux.adoption.rencontre.status.outgoing": "Sent request pending",
  "animaux.adoption.post.see_detail": "View details",
  "animaux.adoption.profile.open": "View profile",
  "animaux.adoption.rencontre.accept": "Accept friend request",
  "animaux.adoption.video.busy": "In a video call",
  "animaux.adoption.video.call": "Video call",
  "common.cancel": "Cancel",
  "animaux.adoption.rencontre.delete_exchange": "Delete exchange",
  "animaux.adoption.rencontre.finalize.confirm": "Confirm exchange",
  "animaux.adoption.rencontre.finalize": "Confirm transaction",
  "animaux.adoption.rencontre.review.add": "Leave a rating and comment",
  "animaux.adoption.post.map": "Listing map",
  "animaux.adoption.contact.show": "Contact",
  "animaux.adoption.friend.accepted": "Friend accepted",
  "animaux.adoption.friend.sent": "Friend request sent",
  "animaux.adoption.friend.send": "Send friend request",
  "animaux.adoption.post.back": "Back to listings",
  "animaux.adoption.publish.t": "Publish",
  "animaux.adoption.publish.hero": "Create a clear, complete listing with a location to find a responsible family.",
  "animaux.adoption.publish.map": "Area map",
  "animaux.adoption.publish.contact_mode.message": "Eternua messaging",
  "animaux.adoption.publish.kind": "Publication type",
  "animaux.adoption.publish.kind.offre": "Animal for adoption",
  "animaux.adoption.publish.kind.demande": "Adoption request",
  "animaux.adoption.publish.objective": "Goal",
  "animaux.adoption.publish.objective.adopter": "Adopt",
  "animaux.adoption.publish.objective.proposer": "Offer for adoption",
  "animaux.adoption.publish.objective.proteger": "Protect",
  "animaux.adoption.publish.animal_type": "Animal type",
  "animaux.adoption.publish.animal_name": "Animal name (optional)",
  "animaux.adoption.publish.animal_name.ph": "E.g. Luna",
  "animaux.adoption.publish.breed": "Breed (optional)",
  "animaux.adoption.publish.breed.choose": "Choose a breed",
  "animaux.adoption.publish.breed.ph": "E.g. breed or mixed breed",
  "animaux.adoption.publish.age": "Age (optional)",
  "animaux.adoption.publish.age.ph": "E.g. 2 years",
  "animaux.adoption.publish.publisher_auto": "Automatic profile (signed-in account)",
  "common.unknown": "unknown",
  "animaux.adoption.browse.friends_count": "Number of friends",
  "animaux.adoption.publish.stats.given": "Animals offered for adoption",
  "animaux.adoption.publish.stats.adopted": "Animals adopted (requests)",
  "animaux.adoption.publish.publisher_bio.empty": "Add a bio to your public profile to display it here automatically.",
  "animaux.adoption.publish.address_source": "Address to use",
  "animaux.adoption.publish.address_source.primary": "Use my primary residence",
  "animaux.adoption.publish.address_source.secondary": "Use my secondary residence",
  "animaux.adoption.publish.address_source.new": "Add a new address",
  "animaux.adoption.publish.address_line": "Address line",
  "animaux.adoption.publish.address_line.ph": "E.g. 12 rue des Lumières",
  "animaux.adoption.publish.city": "City *",
  "animaux.adoption.publish.city.ph": "E.g. Paris",
  "animaux.adoption.publish.cp": "Postal code",
  "animaux.adoption.publish.cp.ph": "E.g. 75011",
  "animaux.adoption.publish.country": "Country",
  "animaux.adoption.publish.area": "Location / area *",
  "animaux.adoption.publish.area.ph": "Neighborhood, area, landmarks…",
  "animaux.adoption.publish.details": "Details *",
  "animaux.adoption.publish.details.ph": "Describe the situation, personality, needs and adoption conditions…",
  "animaux.adoption.publish.photos": "Photos (up to 5)",
  "common.delete": "Delete",
  "animaux.adoption.publish.mobility": "Travel",
  "animaux.adoption.publish.mobility.ready": "Willing to travel",
  "animaux.adoption.publish.mobility.distance": "Distance willing to travel (km)",
  "animaux.adoption.publish.mobility.distance.ph": "E.g. 15",
  "animaux.adoption.publish.mobility.pickup": "Logistics",
  "animaux.adoption.publish.mobility.pickup.label": "The animal can be picked up",
  "animaux.adoption.publish.map_real": "Area map",
  "animaux.adoption.map.open": "Open map",
  "animaux.adoption.map.real_hint": "If the premium map is hidden on your device, use this OSM map.",
  "animaux.adoption.map.used": "Location used",
  "animaux.adoption.publish.address_used": "Address used on the map",
  "animaux.adoption.publish.map_click": "Click to choose a point on the map",
  "animaux.adoption.publish.map_pin": "Listing location",
  "common.reset": "Reset",
  "animaux.adoption.publish.map.zone": "Displayed area",
  "animaux.adoption.publish.map.hint": "Enter a location to show the precise area.",
  "animaux.adoption.map.drag_hint": "Tip: drag to move around the map.",
  "animaux.adoption.publish.map.coords": "Coordinates",
  "animaux.adoption.publish.contact_mode": "Contact methods (1 to 3)",
  "animaux.adoption.publish.contact_mode.telephone": "Phone",
  "animaux.adoption.publish.contact_mode.email": "Email",
  "animaux.adoption.publish.contact_mode.eternua_hint": "Recommended: Eternua messaging lets your contact join your friends network directly.",
  "animaux.adoption.publish.contact_phone": "Phone",
  "animaux.adoption.publish.contact_phone.ph": "E.g. +33 6 12 34 56 78",
  "animaux.adoption.publish.contact_email": "Email",
  "animaux.adoption.publish.contact_email.ph": "E.g. name@email.com",
  "animaux.adoption.publish.contact_info": "Contact message (optional)",
  "animaux.adoption.publish.contact_info.ph": "E.g. Please contact me in the evening",
  "animaux.adoption.publish.consent": "I confirm that this information is accurate and may be published.",
  "animaux.adoption.publish.submit": "Publish",
  "animaux.adoption.publish.recent": "Recent publications",
  "animaux.adoption.publish.empty": "No publications yet.",
  "animaux.adoption.publish.mobility.pickup.short": "Pick up",
  "animaux.adoption.post.open": "View details",
  "animaux.adoption.browse.kind": "Listing type",
  "common.all": "Both",
  "animaux.adoption.browse.distance": "Maximum distance (km)",
  "animaux.adoption.browse.address": "Search address / location",
  "animaux.adoption.browse.address.ph": "E.g. Paris 11",
  "common.apply": "Apply",
  "animaux.adoption.browse.map_real": "Listing map",
  "animaux.adoption.browse.center": "Search center",
  "animaux.adoption.browse.empty": "No listings in this area match these filters.",
  "animaux.adoption.favori.title": "Favorite listings",
  "animaux.adoption.favori.hero": "See your followed listings, friendship status and adoption progress at a glance.",
  "animaux.adoption.favori.empty": "No favorite listings yet.",
  "animaux.adoption.favori.status.available": "Available for adoption",
  "animaux.adoption.favori.status.adopted": "Animal adopted",
  "animaux.adoption.favori.friend.accepted": "Friend request accepted",
  "animaux.adoption.favori.friend.pending": "Friend request pending",
  "animaux.adoption.favori.friend.not_accepted": "Friend request not accepted",
  "animaux.adoption.favori.friend.not_sent": "Friend request not sent",
  "animaux.adoption.favori.status.waiting": "Pending",
  "animaux.adoption.favori.status.friend_ok": "Friend contact active",
  "animaux.adoption.favori.shelve": "Set aside",
  "animaux.adoption.favori.remove": "Remove from favorites",
  "animaux.adoption.favori.shelved_title": "Listings set aside",
  "animaux.adoption.favori.shelved_empty": "No listings set aside.",
  "animaux.adoption.favori.restore": "Move back to the top",
  "animaux.adoption.rencontre.empty": "No requests linked to animal listings yet.",
  "animaux.adoption.viewer": "Photo viewer",
  "animaux.adoption.rencontre.review.dialog": "Adoption review",
  "animaux.adoption.rencontre.review.title": "Leave a rating and comment",
  "animaux.adoption.rencontre.review.rating": "Rating",
  "animaux.adoption.rencontre.review.comment": "Comment",
  "animaux.adoption.rencontre.review.comment.ph": "Your experience",
  "common.save": "Save",
  "babysitting.tab.proposer": "Offer",
  "babysitting.tab.demander": "Request",
  "babysitting.tab.parcourir": "Browse",
  "babysitting.tab.favoris": "Favorites",
  "babysitting.tab.liste": "Childcare list",
  "babysitting.tab.planning_garde": "Childcare schedule",
  "babysitting.tab.planning_demande": "Requested childcare schedule",
  "babysitting.tab.planning_propose": "Proposed schedule",
  "babysitting.tab.planning_recu": "Received schedule",
  "babysitting.tab.affaires_en_cours": "Current deals",
  "babysitting.tab.affaires_terminees": "Completed deals",
  "babysitting.tab.paiement": "Payment",
  "babysitting.tab.paiement_finalise": "Completed payment",
  "market.cat.babysitting.desc": "Childcare, parent support and secure scheduling.",
  "voyage.destination.editorial": "Editorial destination",
  "voyage.destination.default_description": "Inspiration to personalize according to your interests and needs.",
  "voyage.destination.best_period": "Best time to visit",
  "voyage.destination.verify_period": "Check according to your plans",
  "voyage.destination.no_price_availability": "Prices and availability are not provided by Eternua.",
  "voyage.destination.discover": "Discover",
  "voyage.destination.prepare": "Plan this trip",
  "voyage.planner.adults": "Adults",
  "voyage.planner.children": "Children",
  "voyage.planner.transport": "Transport",
  "voyage.transport.indifferent": "No preference",
  "voyage.transport.train": "Train",
  "voyage.transport.avion": "Plane",
  "voyage.transport.voiture": "Car",
  "voyage.transport.bus": "Bus",
  "voyage.transport.ferry": "Ferry",
  "voyage.transport.velo": "Bicycle",
  "voyage.planner.accessibility": "Accessibility or special requirements",
  "voyage.planner.accessibility_private": "Details will be added to the private draft.",
  "voyage.itinerary.progress": "Preparation",
  "voyage.itinerary.progress_unknown": "Not calculated",
  "voyage.itinerary.share": "Share",
  "voyage.itinerary.continue": "Continue my itinerary",
  "voyage.trip.read_only": "Shared trip is read-only: only its owner can edit it.",
  "voyage.destinations.network_error": "Server destinations are unavailable. Local previews remain clearly labeled.",
  "voyage.favorite.error": "The favorite could not be saved.",
  "voyage.save.server_updated": "Draft updated in My Trips.",
  "voyage.save.server_success": "Draft saved in My Trips.",
  "voyage.save.server_error": "The draft could not be saved. Your criteria remain in the URL.",
  "voyage.hero.beta": "Pre-launch · Beta",
  "voyage.destinations.partial_title": "Exploring with limited availability",
  "voyage.destinations.recommended_kicker": "Recommended",
  "voyage.discovery.personal": "Your Travel exploration",
  "voyage.recent.title": "Recently viewed",
  "voyage.recent.empty": "The destinations you discover will appear here.",
  "voyage.favorites.title": "Favorites",
  "voyage.favorites.empty": "Add a destination to find it quickly.",
  "voyage.favorites.login": "Sign in to save your favorites.",
  "voyage.saved.title": "Saved trips",
  "voyage.saved.empty": "Your drafts will appear here after saving.",
  "voyage.saved.login": "Sign in to find your trips.",
  "voyage.departures.title": "Upcoming departures",
  "voyage.departures.empty": "No departures planned yet.",
};
